(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["touch/double-click-control"] = factory();
	else
		root["touch/double-click-control"] = factory();
})(globalThis, () => {
return 